<template>
  <v-row align="center">
    <v-col cols="6">
      <v-select
        class="ml-2"
        outlined
        dense
        hide-details
        item-text="title"
        item-value="value"
        :items="$options.datesTypesEnums"
        :value="getDateTypeValue"
        @change="updateDateType($event)"
      />
    </v-col>
    <v-col
      cols="6"
      v-if="isValidValue"
    >
      <v-menu
        ref="menuDate"
        :close-on-content-click="false"
        :return-value.sync="value"
        transition="scale-transition"
        offset-y
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            outlined
            append-icon="mdi-calendar"
            readonly
            hide-details
            dense
            v-bind="attrs"
            v-on="on"
            :value="preparedFormatTime"
            @change="returnValue"
          />
        </template>
        <v-date-picker
          no-title
          scrollable
          :value="value"
          @change="returnValue"
        >
          <v-spacer />
          <v-btn
            text
            color="primary"
            @click="$refs.menuDate.save(value)"
          >
            OK
          </v-btn>
        </v-date-picker>
      </v-menu>
    </v-col>
  </v-row>
</template>

<script>
import moment from 'moment'
import { defaultDateFormat, apiFormat } from '@/configs/date.js'
const datesTypesEnums = [
  {
    title: 'Даты',
    value: null
  },
  {
    title: 'Сегодня',
    value: 'TODAY'
  }
]
export default {
  name: 'DateWidgetInput',
  datesTypesEnums,
  props: {
    value: {
      type: [String, Date],
      default: new Date()
    },
    entity: {
      type: String,
      default: null
    }
  },
  computed: {
    getDateTypeValue () {
      const foundDateType = datesTypesEnums.find(dateType => dateType.value === this.value)
      if (foundDateType) {
        return foundDateType.value
      }
      return null
    },
    isValidValue () {
      return moment(this.value).isValid() || this.value === null
    },
    preparedFormatTime () {
      if (moment(this.value).isValid()) {
        return moment(this.value).format(defaultDateFormat)
      }
      return null
    }
  },
  methods: {
    updateDateType (value) {
      this.$emit('input', value)
    },
    returnValue (value) {
      this.$emit('input', moment(value).format(apiFormat))
    }
  }
}
</script>
